import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/videos';

export default function ArticleView() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-error-warning-line text-foreground-400 text-5xl"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-700 mb-2">文章未找到</h1>
            <Link
              to="/articles"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-foreground-950 font-semibold px-6 py-2.5 rounded-full text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              返回文章列表
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <article className="max-w-[900px] mx-auto px-4 md:px-6 pb-14">
          <Breadcrumb
            items={[
              { label: t('nav.articles'), to: '/articles' },
              { label: article.title },
            ]}
          />

          <div className="aspect-video rounded-xl overflow-hidden bg-background-200 mb-8">
            <img
              src={article.thumbnail}
              alt={article.title}
              title={article.title}
              className="w-full h-full object-cover"
            />
          </div>

          <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-4">
            {article.title}
          </h1>

          <div className="flex items-center gap-4 text-sm text-foreground-400 mb-8">
            <span className="whitespace-nowrap">
              <i className="ri-user-line mr-1"></i>
              {article.author}
            </span>
            <span className="whitespace-nowrap">
              <i className="ri-calendar-line mr-1"></i>
              {article.date}
            </span>
          </div>

          <div className="prose-custom text-foreground-600 leading-relaxed text-base space-y-4">
            {article.content.split('\n\n').map((paragraph, index) => {
              if (paragraph.startsWith('## ')) {
                return (
                  <h2 key={index} className="text-xl font-bold text-foreground-900 mt-8 mb-4 font-heading">
                    {paragraph.replace('## ', '')}
                  </h2>
                );
              }
              return (
                <p key={index} className="text-foreground-500 leading-relaxed">
                  {paragraph}
                </p>
              );
            })}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/50">
            <Link
              to="/articles"
              className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> 返回文章列表
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}